// API base is env-overridable for local full-stack development: set
// VITE_API_BASE (e.g. http://localhost:8001) in .env.local to point the web
// at a locally running api-getorbitx. Defaults to prod, since this file's
// history is deliberately pinned there ("use prod api").
const BASE = import.meta.env.VITE_API_BASE || "https://devapi.orbitshift.ai"

const URLS = {
  V1: `${BASE}/v1`,
  V2: `${BASE}/v2`,
  ASSETS: `${BASE}/assets`,
  OS_LITE: `${BASE}/v1/os_lite`
}

export default URLS
